import {
  createAsyncThunk,
  createEntityAdapter,
  createSlice,
} from "@reduxjs/toolkit";
import { RootState } from "../../app/store";
import {
  GetSupplementDefinitionsRequest,
  getVariationSpecificSettings,
  VariationSpecificSettings,
} from "./supplementAPI";

type Entities = {
  [key: string]: any;
};

export type SliceState = {
  ids: [];
  entities: Entities;
  status: "idle" | "pending" | "succeeded" | "failed";
  error?: string;
};

const supplementsAdapter = createEntityAdapter();

export const fetchSupplementDefinitions = createAsyncThunk<
  VariationSpecificSettings,
  GetSupplementDefinitionsRequest,
  { state: RootState }
>(
  "supplements/fetchSupplementDefinitions",
  async (
    getSupplementDefinitionsRequest: GetSupplementDefinitionsRequest,
    { requestId },
  ) => {
    const res = await getVariationSpecificSettings(
      getSupplementDefinitionsRequest,
      { requestId },
    );
    return res.data;
  },
);

export const supplementsSlice = createSlice({
  name: "supplements",
  initialState: supplementsAdapter.getInitialState({
    status: "idle",
  }) as SliceState,
  reducers: {},
  extraReducers: (builder) => {
    builder.addCase(fetchSupplementDefinitions.fulfilled, (state) => {
      state.status = "succeeded";
    });
    builder.addCase(fetchSupplementDefinitions.pending, (state) => {
      state.status = "pending";
    });
    builder.addCase(fetchSupplementDefinitions.rejected, (state) => {
      state.status = "failed";
    });
  },
});

export const supplementsReducer = supplementsSlice.reducer;
